import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Screw from '../../../../object-view/objects/screw/screw';
import './styles.scss';
import { setPanelClose, setPanelOptions } from '@reducers/options/panel/actions';
import { setScrewHeightType } from '@reducers/options/screw/actions';
import { setStandOffActiveBtn } from '@reducers/selectors/application/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';


const StandOffs = (props) => (
  <div className="list-type">
    <h4>{APP_TEXTS.GENERAL_CALCULATION_STAND_OFF_LABEL.Content}</h4>
    <ul className="inline-list">
      <li>
        
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_NO_STAND_OFF.Content}>
        <button
          className={`btn btn-light ${props.activeBtn === '1' ? 'ImageButton--active' : ''}`}
          onClick={() => {
            props.setActiveBtn('1');
            props.setScrewType(Screw.types.height.DEFAULT);
            props.resetStandOff();
          }}
        >
          <span className="icon_generalcalculation-standoff-1" />
        </button>
        </Tooltip>
      </li>
      <li>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STAND_OFF_WITHOUT_CLAMPING.Content}>
        <button
          className={`btn btn-light ${props.activeBtn === '2' ? 'ImageButton--active' : ''}`}
          onClick={() => {
            props.setActiveBtn('2');
            props.setScrewType(Screw.types.height.INDENTED);
          }}
        >
        
          <span className="icon_generalcalculation-standoff-2" />
        </button>
        </Tooltip>
      </li>
      <li>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STAND_OFF_WITH_CLAMPING.Content}>
          <button
          className={`btn btn-light ${props.activeBtn === '3' ? 'ImageButton--active' : ''}`}
          onClick={() => {
            props.setActiveBtn('3');
            props.setScrewType(Screw.types.height.INDENTED);
          }}
        >
          <span className="icon_generalcalculation-standoff-3" />
          </button>
        </Tooltip>
      </li>
      <li>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_STAND_OFF_WITH_GROUT.Content}>
         <button
          className={`btn btn-light ${props.activeBtn === '4' ? 'ImageButton--active' : ''}`}
          onClick={() => {
            props.setActiveBtn('4');
            props.setScrewType(Screw.types.height.INDENTED, true);
          }}
        >
          <span className="icon_generalcalculation-standoff-4" />
         </button>
       </Tooltip>
      </li>
    </ul>
  </div>
);


StandOffs.propTypes = {
  setScrewType: PropTypes.func.isRequired,
};

const mapState = state => ({
  activeBtn: state.selectors.application[state.main.appType].activeStandOffBtn
});

const mapDispatch = dispatch => ({
  setScrewType: (heightType, isClosed) => {
    dispatch(setScrewHeightType(heightType));
    dispatch(setPanelClose(isClosed));
  },
  setActiveBtn: id => dispatch(setStandOffActiveBtn(id)),
  resetStandOff: () => {
    dispatch(setPanelOptions({
      standOff: {
        value: 50
      }
    }));
  }
});

export default connect(mapState, mapDispatch)(StandOffs);



// WEBPACK FOOTER //
// ./src/views/Application/types/GeneralCalculation/StandOffs.js